export default __webpack_public_path__ + "static/media/Tayyor1.ce4d7e29.png";